export const GET_PRODUCTS = "product/GET_PRODUCTS";
